import {
  getZapDisplayTitle,
  isUntitledZap,
  ApprovalType,
  FOLDER_TRASH_ID,
} from "@zapier/utils";
import AssetRow from "./AssetRow";
import { HydratedZapAsset, useSplitTreatments, Zap } from "@zapier/client";
import { useZapRow } from "@zapier/zaps/src/zaps/ZapTable/useZapRow";
import { FolderModal, ZapModal, ZapPauseToggle } from "@zapier/shared";
import isUndefined from "lodash.isundefined";

interface Props {
  zap: HydratedZapAsset;
  apps?: Record<string, any>;
  setCurrentModal: (modal: ZapModal | FolderModal | undefined) => void;
  setCurrentZap: (zap: HydratedZapAsset | Zap | undefined) => void;
  setApprovalType: (approvalType: ApprovalType | undefined) => void;
  folderId?: string;
  showCheckboxes?: boolean;
  showLastRun?: boolean;
  showLocationColumn?: boolean;
  onCopyToAnotherAccount?: (asset: HydratedZapAsset) => void;
}

export function AssetRowZap({
  zap,
  apps,
  setCurrentModal,
  setCurrentZap,
  setApprovalType,
  folderId,
  showCheckboxes,
  showLastRun,
  showLocationColumn,
  onCopyToAnotherAccount,
}: Props) {
  const { isZapAndCanvasUnifiedTrashEnabled } = useSplitTreatments();
  const { menuItems, canEnableDisable, triggerPermissionsCheck } = useZapRow({
    zapId: zap.id,
    zap,
    setCurrentModal,
    setCurrentZap,
    onCopyToAnotherAccount,
    isZapPurgeEligible:
      folderId === FOLDER_TRASH_ID && isZapAndCanvasUnifiedTrashEnabled,
  });

  const isUntitled = isUntitledZap(zap.title);
  const title = getZapDisplayTitle(zap.title);
  const updatedAt = new Date(zap.updatedAt || "");
  const showPauseToggle = canEnableDisable && !isUndefined(zap.isEnabled);

  return (
    <AssetRow
      allowSelection={showCheckboxes}
      asset={zap}
      apps={apps}
      folderZapTableRow={true}
      isUntitled={isUntitled}
      title={title}
      onOpenMenu={triggerPermissionsCheck}
      menuItems={menuItems}
      updatedAt={updatedAt}
      lastRunAt={
        typeof zap.searchZap?.lastRunAt === "string"
          ? new Date(zap.searchZap.lastRunAt)
          : zap.searchZap?.lastRunAt
      }
      folderId={folderId}
      showLastRun={showLastRun}
      showLocationColumn={showLocationColumn}
      statusCell={
        showPauseToggle ? (
          <ZapPauseToggle
            zapDeletedAt={zap.deletedAt}
            zapIsPaused={!!zap.isPaused}
            zapIsEnabled={zap.isEnabled}
            zapZdl={zap.currentVersion?.zdl}
            zapCurrentVersionId={zap.currentVersion?.id}
            zapId={zap.id}
            zapTitle={title}
            setApprovalType={setApprovalType}
            setCurrentModal={setCurrentModal}
            setCurrentZap={() => setCurrentZap(zap)}
            isSharedFolder={zap.folder?.isShared}
            canEnableDisable={canEnableDisable}
            folderId={folderId}
          />
        ) : undefined
      }
    />
  );
}
